import { Provider, Signal } from '@angular/core';

import { createRbacContext, JwtTokenStore, RBAC_CONTEXT, SecurityRoles } from '@portal/shared/utils';

export function provideRBACContext(): Provider[] {
    return [
        {
            provide: RBAC_CONTEXT,
            deps: [JwtTokenStore],
            useFactory: (jwtStore: { $userId: Signal<number | null>; $userRole: Signal<SecurityRoles | null> }) =>
                createRbacContext(jwtStore.$userId(), jwtStore.$userRole()),
        },
    ];
}
